/**
 * External modules
 */
import React from "react";
import ReactDOM from "react-dom/client";
import { RecoilRoot } from "recoil";

/**
 * Internal modules
 */
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  // </React.StrictMode>
);
